(function () {
  const CART_PROMO_PROPERTY = '_cart_promo_item';
  let isRemovingPromo = false;

  const REMOVE_ICON_SVG = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.66675 3.31325L5.81341 2.43992C5.92008 1.80659 6.00008 1.33325 7.12675 1.33325H8.87341C10.0001 1.33325 10.0867 1.83325 10.1867 2.44659L10.3334 3.31325" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.5667 6.09326L12.1334 12.8066C12.06 13.8533 12 14.6666 10.14 14.6666H5.86002C4.00002 14.6666 3.94002 13.8533 3.86668 12.8066L3.43335 6.09326" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.88672 11H9.10672" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.33325 8.33325H9.66659" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

  function isRealCartItem(item) {
    const handle = item.handle || '';
    const props = item.properties || {};
    return !(
      handle.includes('shipping-protection') ||
      handle.includes('navidium') ||
      props['_gwp-product'] ||
      props['_subscription_bundle_main_sub_product_id'] ||
      props[CART_PROMO_PROPERTY]
    );
  }

  function handlePromoAutoRemove(cartState) {
    if (isRemovingPromo || !cartState || !Array.isArray(cartState.items)) return;

    const promoItem = cartState.items.find(
      (item) => item.properties && item.properties[CART_PROMO_PROPERTY]
    );
    if (!promoItem) return;

    const hasRealItems = cartState.items.some(isRealCartItem);
    if (hasRealItems) return;

    isRemovingPromo = true;
    updateCardAttribute(false);
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.updateQuantity === 'function') {
      cartDrawerItems.updateQuantity(promoItem.line, 0, undefined, promoItem.key);
    }
    setTimeout(() => {
      isRemovingPromo = false;
    }, 3000);
  }

  function updateCardAttribute(inCart) {
    fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { card: inCart ? 'true' : '' } }),
    }).catch(() => {});
  }

  let _cartStateValue = window._cartState;
  try {
    Object.defineProperty(window, '_cartState', {
      configurable: true,
      get() {
        return _cartStateValue;
      },
      set(value) {
        _cartStateValue = value;
        handlePromoAutoRemove(value);
      },
    });
  } catch (e) {}

  function applyOptimisticRemove() {
    const promoBlock = document.querySelector('.cart-promo-block');
    if (promoBlock) promoBlock.classList.remove('js-promo-banner-hidden');

    const promoItem = document.querySelector('.cart-item--promo:not(.cart-item--optimistic-promo)');
    if (promoItem) promoItem.style.display = 'none';
  }

  function applyOptimisticAdd(btn) {
    const promoBlock = btn.closest('.cart-promo-block');
    if (promoBlock) promoBlock.classList.add('js-promo-banner-hidden');

    // Insert optimistic cart item before the banner
    const rowgroup = document.querySelector(
      '#CartDrawer-CartItems .drawer__cart-items-wrapper [role="rowgroup"]'
    );
    if (rowgroup && promoBlock) {
      const img = btn.dataset.productImage || '';
      const img2x = btn.dataset.productImage2x || '';
      const alt = btn.dataset.productImageAlt || '';
      const title = btn.dataset.productTitle || '';

      const el = document.createElement('div');
      el.className = 'cart-item cart-item--gwp cart-item--promo cart-item--optimistic-promo';
      el.setAttribute('role', 'row');
      el.innerHTML = `
        <div class="cart-item--gwp__inner">
          <div class="cart-item--gwp__image-wrap">
            <img class="cart-item--gwp__image"
              src="${img}" srcset="${img} 1x, ${img2x} 2x"
              alt="${alt}" width="24" height="24" />
          </div>
          <span class="cart-item--gwp__text"><strong>${title}</strong></span>
          <div class="cart-item--promo__remove">
            <button class="cart-item--promo__remove-btn" type="button" disabled>
              ${REMOVE_ICON_SVG}
            </button>
          </div>
        </div>`;
      rowgroup.insertBefore(el, promoBlock);
    }

  }

  function revertOptimisticAdd() {
    document.querySelector('.cart-item--optimistic-promo')?.remove();

    const promoBlock = document.querySelector('.cart-promo-block');
    if (promoBlock) promoBlock.classList.remove('js-promo-banner-hidden');

  }

  async function addPromoToCart(btn) {
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('loading');
    const spinner = btn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    applyOptimisticAdd(btn);

    const cartDrawer = document.querySelector('cart-drawer');
    const sections =
      cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((s) => s.id)
        : ['cart-drawer', 'cart-icon-bubble'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append(`properties[${CART_PROMO_PROPERTY}]`, 'true');
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    try {
      const resp = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const data = await resp.json();

      if (data.status) {
        console.error('[CartPromo] Add failed:', data.description);
        revertOptimisticAdd();
        btn.disabled = false;
        btn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        return;
      }

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data, 'add-to-cart-form');
      }

      updateCardAttribute(true);

      if (typeof updateCartAndProductJSON === 'function') {
        updateCartAndProductJSON();
      }
    } catch (err) {
      console.error('[CartPromo] Add error:', err);
      revertOptimisticAdd();
      btn.disabled = false;
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function tryInjectOptimisticPromoBlock() {
    const rowgroup = document.querySelector('#CartDrawer-CartItems [role="rowgroup"]');
    if (!rowgroup) return;
    if (rowgroup.querySelector('.cart-promo-block:not(.js-promo-banner-hidden)')) return;
    if (rowgroup.querySelector('.cart-item--promo')) return;
    if (rowgroup.querySelector('.cart-promo-block--optimistic')) return;

    const template = document.getElementById('cart-promo-block-tpl');
    if (!template) return;

    const clone = template.content.cloneNode(true);
    const el = clone.querySelector('.cart-promo-block');
    if (el) el.classList.add('cart-promo-block--optimistic');
    rowgroup.appendChild(clone);
  }

  const _cartDrawerItemsEl = document.querySelector('#CartDrawer-CartItems');
  if (_cartDrawerItemsEl) {
    new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (
            (node.classList.contains('cart-item--skeleton') || node.classList.contains('cart-item--optimistic')) &&
            !node.classList.contains('cart-promo-block') &&
            !node.classList.contains('cart-item--promo')
          ) {
            tryInjectOptimisticPromoBlock();
            return;
          }
        }
      }
    }).observe(_cartDrawerItemsEl, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (evt) {
    const addBtn = evt.target.closest('.js-cart-promo-add');
    if (addBtn && !addBtn.disabled) {
      addPromoToCart(addBtn);
      return;
    }

    const removeBtn = evt.target.closest('.cart-item--promo .cart-item--promo__remove-btn');
    if (removeBtn && !removeBtn.disabled) {
      applyOptimisticRemove();
      updateCardAttribute(false);
    }

    const checkbox = evt.target.closest('[data-cart-promo-checkbox]');
    if (checkbox) {
      togglePromoCheckbox(checkbox);
    }
  });

  function togglePromoCheckbox(checkbox) {
    if (checkbox.classList.contains('is-loading') || checkbox.classList.contains('is-disabled')) return;
    if (checkbox.classList.contains('is-checked')) {
      removePromoFromCheckbox(checkbox);
    } else {
      addPromoFromCheckbox(checkbox);
    }
  }

  function startCheckboxLoading(checkbox, nextChecked) {
    checkbox.classList.add('is-loading');
    checkbox.classList.toggle('is-checked', !!nextChecked);
    checkbox.setAttribute('aria-checked', nextChecked ? 'true' : 'false');
  }

  function endCheckboxLoading(checkbox, nextChecked) {
    checkbox.classList.remove('is-loading');
    checkbox.classList.toggle('is-checked', !!nextChecked);
    checkbox.setAttribute('aria-checked', nextChecked ? 'true' : 'false');
  }

  async function addPromoFromCheckbox(checkbox) {
    const variantId = parseInt(checkbox.dataset.variantId, 10);
    if (!variantId) return;

    startCheckboxLoading(checkbox, true);

    const cartDrawer = document.querySelector('cart-drawer');
    const sections =
      cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((s) => s.id)
        : ['cart-drawer', 'cart-icon-bubble'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append(`properties[${CART_PROMO_PROPERTY}]`, 'true');
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    try {
      const resp = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await resp.json();
      if (data.status) {
        console.error('[CartPromo] Checkbox add failed:', data.description);
        endCheckboxLoading(checkbox, false);
        return;
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data, 'add-to-cart-form');
      }
      updateCardAttribute(true);
      if (typeof updateCartAndProductJSON === 'function') updateCartAndProductJSON();
    } catch (err) {
      console.error('[CartPromo] Checkbox add error:', err);
      endCheckboxLoading(checkbox, false);
    }
  }

  async function removePromoFromCheckbox(checkbox) {
    const lineKey = checkbox.dataset.lineKey;
    if (!lineKey) return;

    startCheckboxLoading(checkbox, false);

    const cartDrawer = document.querySelector('cart-drawer');
    const sections =
      cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((s) => s.id)
        : ['cart-drawer', 'cart-icon-bubble'];

    try {
      const resp = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: lineKey, quantity: 0, sections: sections.join(','), sections_url: window.location.pathname }),
      });
      const data = await resp.json();
      if (data.status) {
        console.error('[CartPromo] Checkbox remove failed:', data.description);
        endCheckboxLoading(checkbox, true);
        return;
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data, 'cart-drawer-promo-remove');
      }
      updateCardAttribute(false);
      if (typeof updateCartAndProductJSON === 'function') updateCartAndProductJSON();
    } catch (err) {
      console.error('[CartPromo] Checkbox remove error:', err);
      endCheckboxLoading(checkbox, true);
    }
  }
})();
